import styled from 'styled-components';

export const ProfileContainer = styled.div`
  width: 100%;
  padding: 6px 15px;
  margin-bottom: 12px;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const ProfileShortCutIconWrapper = styled.div`
  position: absolute;
  right: 20px;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ theme }) => theme['font-secondary']};
    }
  }
`;

export const SettingGroupContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SeperateLine = styled.div`
  width: 100%;
  height: 8px;

  background-color: ${({ theme }) => theme['warmgray-50']};
`;
